import {API_URL} from "../constants";
import axios from "axios";

export const apiPriceCreate = (token: string, {
  route,
  city_from,
  city_to,
  price
}: any): any => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}/price/create`, {
        route_id: route ? route.id : null,
        city_from_id: city_from ? city_from.id : null,
        city_to_id: city_to ? city_to.id : null,
        price
      }, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + token,
        },
      })
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export const apiPriceUpdate = (token: string, id: number, {
  city_from,
  city_to,
  route,
  price
}: any): any => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}/price/update`, {
        id,
        route_id: route ? route.id : null,
        city_from_id: city_from ? city_from.id : null,
        city_to_id: city_to ? city_to.id : null,
        price
      }, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + token,
        },
      })
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export const apiPriceDelete = (token: string, id: number): any => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}/price/delete`, {
        id,
      }, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + token,
        },
      })
      .then(function (response) {
        resolve(response.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export const apiPricesGet = (token: string, {
  offset, limit, search
}: {
  offset: number,
  limit: number,
  search: string
}): any => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}/prices?offset=${offset}&limit=${limit}&search=${search}`, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + token,
        },
      })
      .then(function (response) {
        resolve({
          elements: response.data.prices,
          num: response.data.num
        });
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

